// extracted by mini-css-extract-plugin
export default {"menuLink":"menu_menuLink__O+BaG","signUpBtn":"menu_signUpBtn__aFpRo"};